import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    color: "#000000",
    letterSpacing: 0,
    gap: "5px",
  },
  mobile_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    color: "#000000",
    letterSpacing: 0,
  },
  leftText: {
    fontSize: "24px",
  },
  mobile_leftText: {
    fontSize: "18px",
    marginBottom: "6px",
  },
  centerText: {
    fontSize: "24px",
    color: "#00833E",
    fontWeight: 500,
  },
  mobile_centerText: {
    fontSize: "20px",
    color: "#00833E",
    fontWeight: 500,
  },

  rightText: {
    fontSize: "18px",
    fontWeight: 500,
    color: "#00833E",
    marginBottom: "3px",
  },
  mobile_rightText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#00833E",
  },
}));

export default useStyles;
